export default __webpack_public_path__ + "static/media/logo-court.57c064ea.png";